<template lang="pug">
v-sheet.pb-16.pt-0.py-sm-16.px-2.px-sm-8.px-md-16.d-flex.align-center
  v-container(fluid)
    v-row(justify="center")
      v-col(cols=12 sm=8 md=12)
        v-row(justify="space-around" align="center")
          v-col(v-if="$vuetify.breakpoint.smAndDown" cols=12 md=6)
            v-img(
              src="../../assets/illustrations/erudio_cadeado.svg"
              alt="Imagem aprendizado na palma da mão"
              transition="scroll-from-right-slow"
              min-height=190
            )
          v-col(cols=12 md=6)
            h3.mb-6.ibm.text-h4.text-md-h3.primary--text Sabemos o valor do seu conteúdo.
            p.mb-14.text-body-1.text-md-h6.font-weight-regular.heebo.grey--text.text--darken-4 No Erudio, suas videoaulas e materiais recebem a melhor criptografia do mercado para evitar que seu material seja pirateado.
            v-btn.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
              color="primary"
              depressed
              :block="$vuetify.breakpoint.smAndDown"
              height=56
              @click="$goTo({ path: '/', target: '#selectInst' })"
            ) Quero começar agora!
          v-col(v-if="$vuetify.breakpoint.mdAndUp" cols=12 md=6)
            v-img(
              src="../../assets/illustrations/erudio_cadeado.svg"
              alt="Imagem aprendizado na palma da mão"
              transition="scroll-from-right-slow"
              min-height=190
            )
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="sass" scoped></style>
